import { render, staticRenderFns } from "./BranchEditTabAccount.vue?vue&type=template&id=5c6335d2&"
import script from "./BranchEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./BranchEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./BranchEditTabAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports